const widgetsToPrefetchOnInit = require('./translations_preload/widget_translations_on_init');
const widgetResourceManager = require('./widget_resource_manager');

module.exports = widgetResourceManager({
    getUrlService() {
        return Odigeo.Settings.property('appContext') + Odigeo.Settings.property('translationsUrlPrefix');
    },
    getSessionScope() {
        return Odigeo.SessionScope;
    },
    widgetsToPrefetchOnInit,
    resourceType: 'Translations',
    hasStaticResources: false,
});
